/**
 * WebView 86 / Fully Kiosk иногда отдают тело ответа строкой
 * (пустой xhr.responseType), даже при Content-Type: application/json.
 */
export function parseMonitorResponse<T>(data: unknown): T {
  if (typeof data === 'string') {
    const trimmed = data.trim();
    if (!trimmed) {
      throw new Error('Empty monitor response');
    }
    return JSON.parse(trimmed) as T;
  }
  return data as T;
}
